module.exports = __webpack_public_path__ + "static/img/day8.90c68ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day8.jpg
// module id = nJAF
// module chunks = 0